import { render, staticRenderFns } from "./TotemHelpVideoDialog.vue?vue&type=template&id=01cc868d&scoped=true"
import script from "./TotemHelpVideoDialog.vue?vue&type=script&lang=js"
export * from "./TotemHelpVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./TotemHelpVideoDialog.vue?vue&type=style&index=0&id=01cc868d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc868d",
  null
  
)

export default component.exports